import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { showMenu } = {}) => ({
  option: { borderBottom: '1px solid #F4F4F4' },
  root: {
    width: 350,
    [theme.breakpoints.down('sm')]: {
      width: '77vw',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 20,
      boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      padding: '5px 12px !important',
    },
    '& fieldset': {
      border: 'none',
    },
  },
  searchIcon: {
    color: theme.palette.grey2,
    marginRight: theme.spacing(0.5),
  },
  progress: {
    alignItems: 'center',
    display: 'flex',
    height: 27,
    marginRight: theme.spacing(1),
    '& span': {
      height: '18px !important',
      width: '18px !important',
    },
  },
  paper: {
    display: showMenu ? 'block' : 'none',
    borderRadius: 20,
    marginTop: theme.spacing(1),
  },
  listbox: {
    '& .MuiAutocomplete-option': {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
  },
  matchText: {
    color: '##929A92',
    fontSize: 12,
    padding: theme.spacing(2),
  },
}));
